<template>
  <div v-if="bars.length > 2" class="w-full h-full grid" :style="{ gridTemplateColumns: `repeat(${bars.length - 1}, 1fr)` }">
    <div v-for="cardIndex in bars.length - 2" :key="`${mirror ? 'bottom' : 'top'}-card-${cardIndex}`" 
    class="relative w-full h-full">
      <div class="bar absolute left-0 transform -translate-x-1/2" :style="getBarStyle(cardIndex - 1)" />
    </div>
    <div class="relative w-full h-full">
      <div class="bar absolute left-0 transform -translate-x-1/2" :style="getBarStyle(bars.length - 2)" />
      <div class="bar absolute right-0 transform translate-x-1/2" :style="getBarStyle(bars.length - 1)" />
    </div>
  </div>
</template>

<script>
const GRAPH_AREA_HEIGHT = 140

export default {
  name: 'BarGraphRenderer',
  props: {
    values: {
      type: Array,
      required: true
    },
    scale: {
      required: true
    },
    mirror: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      animatedIn: false
    }
  },
  mounted () {
    this.$nextTick(() => {
      setTimeout(() => {
        this.animatedIn = true
      }, 10)
    })
  },
  computed: {
    bars () {
      if (!this.scale) return []
      const rangedScale = this.scale.range([0, GRAPH_AREA_HEIGHT])
      return this.values.map((value, index) => ({
        value,
        height: `${rangedScale(value)}px`,
        key: `${this.mirror ? 'bottom' : 'top'}-bar-${index}`
      }))
    }
  },
  methods: {
    getBarStyle (index) {
      const bar = this.bars?.[index]
      if (!bar) return {}
      return {
        top: this.mirror ? '2px' : 'auto',
        bottom: this.mirror ? 'auto' : '1px',
        width: 'round(up, 40%, 1px)',
        height: this.animatedIn ? bar.height : '0px',
        backgroundColor: this.mirror ? '#DFE1E7' : '#00C7A9'
      }
    }
  }
}
</script>

<style scoped>
.bar {
  max-width: 16px;
  min-width: 4px;
  border-radius: 3px;
  transition: height 500ms ease-in-out;
}
</style>